import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useForm } from 'react-hook-form'

import {
  AccomodationEnum,
  accomodationEnumMapping
} from '../../../lib/types/enums/accomodation-type/accomodation-type'
import { JourneyPlaceInput } from '../../../lib/types/models/journey-place/journey-place-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { getSelectedEnumOption } from '../../../lib/utils/functions/misc.functions'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../elements/validation-buttons'
import { journeyPlaceFormSchema } from './utils'

type Props = BaseFormProps<JourneyPlaceInput, true> & {
  className?: string
}

const JourneyPlaceLightForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const form = useForm<JourneyPlaceInput>({
    resolver: zodResolver(journeyPlaceFormSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex gap-4 flex-col', className)}>
          <FormField
            control={form.control}
            name={'name'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput required {...field} label={'NOM du lieu'} type={'text'} />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name={'accomodation'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledSelectInput
                    required
                    {...field}
                    label={"Type d'hébergement"}
                    options={Object.values(AccomodationEnum).map((option) => ({
                      label: accomodationEnumMapping[option],
                      value: option
                    }))}
                    selectedOption={getSelectedEnumOption(field.value, accomodationEnumMapping)}
                    onChange={(value) =>
                      form.setValue('accomodation', value, { shouldValidate: true })
                    }
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default JourneyPlaceLightForm
